import { render, staticRenderFns } from "./LesiurtabContent.vue?vue&type=template&id=74bfa980&scoped=true"
import script from "./LesiurtabContent.vue?vue&type=script&lang=js"
export * from "./LesiurtabContent.vue?vue&type=script&lang=js"
import style0 from "./LesiurtabContent.vue?vue&type=style&index=0&id=74bfa980&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74bfa980",
  null
  
)

export default component.exports